import './style.scss';
import { Spin, Empty } from 'antd';
import RecognitionReward from 'src/_shared/components/recognition-reward/RecognitionReward';
import { useHistory } from 'react-router-dom';

const RecognitionRewardsPresentation = ({ 
  recognitions, 
  currentUser, 
  isLoading, 
  onStateChange 
}) => {
  const history = useHistory();
  
  const activeRecognitions = recognitions.filter(
    recognition => !(recognition.status === 'expired' && recognition.status !== 'unviewed')
  );
  
  const sortedRecognitions = [...activeRecognitions].sort((a, b) => {
    if (a.status === 'unviewed' && b.status !== 'unviewed') return -1;
    if (a.status !== 'unviewed' && b.status === 'unviewed') return 1;
    return new Date(b.createdAt) - new Date(a.createdAt);
  });

  if (isLoading) {
    return (
      <div className="home">
        <div className="recognition-rewards d-card height-equal">
          <div className="d-card-head recognition-rewards-header">
            <h4 className="dashboard-title">MY RECOGNITIONS</h4>
          </div>
          <div className="recognition-rewards-loading">
            <Spin size="large" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="home">
      <div className="recognition-rewards d-card height-equal">
        <div className="d-card-head recognition-rewards-header">
          <h4 className="dashboard-title">MY RECOGNITIONS</h4>
          <div
            className="recognition-rewards-view-all"
            onClick={() => {
              history.push('/my-recognitions');
            }}
          >
            <strong>View All</strong>
          </div>
        </div>
        <div className="recognition-rewards-description">
          Celebrate your achievements with special recognitions and rewards!
        </div>
        
        <div className="recognition-rewards-list">
          {sortedRecognitions.length > 0 ? (
            sortedRecognitions.slice(0, 3).map((recognition) => (
              <RecognitionReward
                key={recognition.id}
                recognition={recognition}
                currentUser={currentUser}
                onStateChange={onStateChange}
              />
            ))
          ) : (
            <Empty 
              description="No recognitions yet" 
              image={Empty.PRESENTED_IMAGE_SIMPLE} 
            />
          )}
        </div>
        
        {sortedRecognitions.length > 3 && (
          <div 
            className="recognition-rewards-view-more"
            onClick={() => {
              history.push('/my-recognitions');
            }}
          >
            View more recognitions
          </div>
        )}
      </div>
    </div>
  );
};

export default RecognitionRewardsPresentation;
